import { render, staticRenderFns } from "./personal_center.vue?vue&type=template&id=339115ad&scoped=true"
import script from "./personal_center.vue?vue&type=script&lang=js"
export * from "./personal_center.vue?vue&type=script&lang=js"
import style0 from "./personal_center.vue?vue&type=style&index=0&id=339115ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339115ad",
  null
  
)

export default component.exports